import { css, type RuleSet } from "styled-components";
import { Breakpoint } from "../constants/breakpoint";
export const getMobileCSS = (template: RuleSet<object>) => {
    return css`
        @media (max-width: ${Breakpoint.mobileBreakpointMaxWidth}) {
            ${template}
        }
    `;
};
